import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { ISearch } from '../types/search'

export const selectSearch = ({ search }: AppStateType): ISearch => search

export const selectItems = createSelector(
  selectSearch,
  ({ items }: ISearch): any[] => items
)

export const selectSkipQuery = createSelector(
  selectSearch,
  ({ skip }: ISearch): number => skip
)
